import { render, staticRenderFns } from "./LgtsAssetDetails.vue?vue&type=template&id=7200302c&scoped=true"
import script from "./LgtsAssetDetails.vue?vue&type=script&lang=js"
export * from "./LgtsAssetDetails.vue?vue&type=script&lang=js"
import style0 from "./LgtsAssetDetails.vue?vue&type=style&index=0&id=7200302c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7200302c",
  null
  
)

export default component.exports